import React from 'react';
import clsx from 'clsx';

import scss from './TagList.module.scss';

function Tag({ tag, onClick, isSelected }) {
  const handleClick = () => {
    onClick?.(tag);
  };

  return (
    <li
      className={clsx(scss.tag, onClick && scss.clickable, isSelected && scss.selected)}
      onClick={handleClick}
      role='presentation'>
      <span>#{tag}</span>
    </li>
  );
}

export default Tag;
